import { useEffect, useRef } from 'react'

type IntervalFunction = () => unknown | void

export function useInterval(callback: IntervalFunction, delay?: number) {
  const savedCallback = useRef<IntervalFunction | null>(null)
  useEffect(() => {
    savedCallback.current = callback
  })

  useEffect(() => {
    function tick() {
      if (savedCallback.current !== null) {
        savedCallback!.current()
      }
    }
    if (delay !== undefined) {
      const intervalId = setInterval(tick, delay)
      return () => clearInterval(intervalId)
    }
  }, [delay])
}
